import React, {FC} from "react";
import {Button, CircularProgress, Grid, Typography} from "@material-ui/core";
import {TimePicker} from "@material-ui/pickers";
import {getDate, getHours, getMinutes, getMonth, getYear, isWithinInterval, set} from "date-fns";
import {FeOrder, WorkerDay} from "../../orders/redux/types";
import {LabeledTextDisplay} from "../../../sharedComponents/LabeledTextDisplay";
import {formatDate} from "../../../date.utils";
import {useCreateOrder} from "../../orders/redux/orders.hook";
import {useHistory} from "react-router-dom";

type NextAppointmentFormProps = {
    oldOrder: FeOrder;
    dayDate: Date;
    workerDay: WorkerDay;
    onFinish: () => void;
};
export const NextAppointmentForm: FC<NextAppointmentFormProps> = ({
                                                                      oldOrder: {id, ...oldOrderObj},
                                                                      dayDate,
                                                                      workerDay,
                                                                      onFinish
                                                                  }) => {

    const {createOrder} = useCreateOrder();

    const history = useHistory();

    const [orderBooked, setOrderBooked] = React.useState(false);

    const [newEstimatedFrom, setNewEstimatedFrom] = React.useState(oldOrderObj.estimatedFrom);
    const [newEstimatedTo, setNewEstimatedTo] = React.useState(oldOrderObj.estimatedTo);

    const [isLoading, setIsLoading] = React.useState(false);

    const [error, setError] = React.useState<string | null>(null);

    const handleBookOrder = () => {
        setIsLoading(true);
        const isCollidingWithOrders = workerDay.orders.some(o =>
                isWithinInterval(
                    newEstimatedFrom,
                    {start: o.estimatedFrom, end: o.estimatedTo}
                ) && isWithinInterval(
                    newEstimatedFrom,
                    {start: o.estimatedFrom, end: o.estimatedTo}
                )
        );

        if (isCollidingWithOrders) {
            setError("Darf sich nicht mit anderem Auftrag überscheiden");
        } else {
            setError(null);
            setOrderBooked(true);
            createOrder({
                ...oldOrderObj,
                from: null,
                to: null,
                estimatedFrom: set(
                    newEstimatedFrom, {
                        date: getDate(dayDate),
                        month: getMonth(dayDate),
                        year: getYear(dayDate)
                    }).getTime(),
                estimatedTo: set(
                    newEstimatedTo, {
                        date: getDate(dayDate),
                        month: getMonth(dayDate),
                        year: getYear(dayDate)
                    }).getTime()
            })
                .then((res) => {
                    history.push("/worker/order/" + (res.payload as FeOrder).id);
                    setIsLoading(false);
                    onFinish();
                });
        }
    }


    return orderBooked ?
        <React.Fragment>{isLoading && <CircularProgress/>}</React.Fragment>
        : (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h6" color="secondary">Neuer Folgetermin</Typography>
                </Grid>
                <Grid item xs={12}>
                    <LabeledTextDisplay label="Datum" value={formatDate(dayDate, "EEEE, dd.MM.yyyy")}/>
                </Grid>
                <Grid item xs={6}>
                    <TimePicker
                        cancelLabel={"Zurück"}
                        ampm={false}
                        label="Start"
                        value={newEstimatedFrom}
                        format={"HH:mm"}
                        onChange={(date) => {
                            if (date) {
                                const newDate = set(
                                    newEstimatedFrom,
                                    {
                                        hours: getHours(date),
                                        minutes: getMinutes(date)
                                    }
                                );
                                setNewEstimatedFrom(newDate.getTime())
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TimePicker
                        cancelLabel={"Zurück"}

                        ampm={false}
                        label="ca. Ende"
                        value={newEstimatedTo}
                        format={"HH:mm"}
                        onChange={(date) => {
                            if (date) {
                                const newDate = set(
                                    newEstimatedTo,
                                    {
                                        hours: getHours(date),
                                        minutes: getMinutes(date)
                                    }
                                );
                                setNewEstimatedTo(newDate.getTime())
                            }
                        }}
                    />
                </Grid>
                {error && <Typography color="error">{error}</Typography>}
                {!isLoading
                    ? (
                        <Grid item xs={12}>
                            <Button
                                style={{marginTop: 16}}
                                variant="contained"
                                color="primary"
                                onClick={handleBookOrder}
                            >
                                Folgetermin Buchen
                            </Button>
                        </Grid>
                    )
                    : <CircularProgress/>
                }
            </Grid>
        );
}
